// extracted by mini-css-extract-plugin
export default {"collapsibleTextBoxWrapper":"MoUS33","collapsedTextBox":"wQPskT","readTextButton":"unjMT6"};